import React from 'react';
import Grid from '@material-ui/core/Grid';
import { cartAddItem } from '../reducers/cart';
import { TextField, Typography, Fab } from '@material-ui/core';


export const getCartQuantity = (cart, product) => {
  if (typeof cart === 'undefined' || cart.items == null)
    return 0;
  for (let i = 0; i < cart.items.length; i++) {
    if (cart.items[i].product.id === product.id) {
      return cart.items[i].quantity;
    }
  }
  return 0;
}
export const getTotalCartQuantity = cart => {
  if (typeof cart === 'undefined' || cart.items == null)
    return 0;
  let count = 0;
  if (cart.items != null) {
    for (let i = 0; i < cart.items.length; i++) {
      count += cart.items[i].quantity;
    }
  }
  return count;
}
export const getCartTotal = cart => {
  if (typeof cart === 'undefined' || cart.items == null)
    return 0;
  let price = 0;
  if (cart.items != null) {
    for (let i = 0; i < cart.items.length; i++) {
      price += cart.items[i].quantity * cart.items[i].product.price;
    }
  }
  return getMoney(price);
}
export const getMoney = price => {
  const p = price ? parseFloat(price) : parseFloat(0);
  return p.toLocaleString(undefined, { style: 'currency', currency: 'SEK', currencyDisplay: 'code' });
}

const AddToCart = ({ item, brewery, cart, dispatch, style }) => {
  const cartQuantity = getCartQuantity(cart, item);
  const quantity = cartQuantity ? cartQuantity : 0;
  const price = getMoney(item.price);
  return (
    <Grid container>
      <Grid item xs={6} md={4} align="center">
        <Typography color={item.quantity > 0 ? 'primary' : 'error'}>
          I lager: {item.quantity} kolli/fat
        </Typography>
      </Grid>
      <Grid item xs={6} md={4} align="center">
        {price}
      </Grid>
      <Grid item xs={12} md={4} align="center">
      <Fab size="small" onClick={() => dispatch(cartAddItem(brewery, item, cartQuantity - 1))}>-</Fab>
      <TextField
          onChange={event => dispatch(cartAddItem(brewery, item, event.target.value === '' ? 0 : parseInt(event.target.value)))}
          name="quantity"
          value={quantity}
          type="number"
          style={{ width: '4em', style }}
          inputProps={{ min: 0, style: { textAlign: 'center' } }}
          InputProps={{ }}
        />
        <Fab size="small" onClick={() => dispatch(cartAddItem(brewery, item, cartQuantity + 1))}>+</Fab>
      </Grid>
    </Grid>
  )
}

export default AddToCart;
